import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { z } from 'zod';
import { createAuthMutation } from '../auth-http-client';

export const createBlockGameMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/games/block/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(z.null()),
		},
	});
